module.exports = __webpack_public_path__ + "static/authtoreceive-21702a804025fb9abb53d250afb79f9a.pdf";